const toUpper = require('mn-utils/toUpper');

const TESTING = process.env.MOCK
  || process.env.DEV
  || process.env.TESTING
  || process.env.SANDBOX;

const BSC_URL_PREFIX = TESTING
  ? 'https://testnet.bscscan.com/tx/'
  : 'https://bscscan.com/tx/';

const ETH_URL_PREFIX = TESTING
  ? 'https://ropsten.etherscan.io/tx/'
  : 'https://etherscan.io/tx/';

const XRP_URL_PREFIX = TESTING
  ? 'https://testnet.xrpl.org/transactions/'
  : 'https://livenet.xrpl.org/transactions/';

const TRX_URL_PREFIX = TESTING
  ? 'https://shasta.tronscan.org/#/transaction/'
  : 'https://tronscan.org/#/transaction/';

const BTC_URL_PREFIX = TESTING
  ? 'https://www.blockchain.com/btc-testnet/tx/'
  : 'https://www.blockchain.com/en/btc/tx/';

const EXPLORER_MAP = {
  BTC: BTC_URL_PREFIX,
  BITCOIN: BTC_URL_PREFIX,
  ETH: ETH_URL_PREFIX,
  ERC: ETH_URL_PREFIX,
  ETHEREUM: ETH_URL_PREFIX,
  BSC: BSC_URL_PREFIX,
  BNB: BSC_URL_PREFIX,
  XRP: XRP_URL_PREFIX,
  RIPPLE: XRP_URL_PREFIX,
  TRX: TRX_URL_PREFIX,
  TRC: TRX_URL_PREFIX,
  TRON: TRX_URL_PREFIX,
};


module.exports = (coinCode) => {
  return EXPLORER_MAP[toUpper(coinCode || '').split('_')[0]];
};
